<template>
  <div class="tabs-extension main-menu">
    <main-menu-grouping />

    <menu-report-context-menu></menu-report-context-menu>

    <template v-if="!!currentReportType">
      <div
        class="layout layout-btn-group underline menu-layout"
        style="display: flex; justify-content: flex-end"
      >
        <div style="display: flex; flex-grow: 1; max-width: unset; width: 100%">
          <div
            v-show="isReport"
            class="main-menu__drilldown-row"
            style="flex: 1 1 auto; min-width: 0"
          >
            <div class="mr-4 ml-4" style="display: flex; flex-wrap: wrap">
              <menu-tree-levels
                v-if="isReport && isBasicReport && isTreeLevelsAllowed"
                class="mt-12"
                style="flex-grow: 0"
              ></menu-tree-levels>
            </div>

            <div
              class="mr-4 ml-4"
              style="flex-grow: 1; display: flex; flex-wrap: wrap; overflow: hidden"
            >
              <menu-drilldown
                v-show="isBasicReport"
                class="mt-12"
                style="flex-grow: 1"
              ></menu-drilldown>
            </div>
          </div>
        </div>

        <div
          class="picker__wrap menu-layout__row mb-8 mt-8"
          style="overflow: hidden; flex: 1 1 auto; min-width: 0"
        >
          <div
            class="menu-layout__pickers"
            style="flex-grow: 1 !important; overflow: hidden"
          >
            <div
              class="pickers-container"
              style="flex-grow: 1; display: flex; flex-wrap: wrap; overflow: hidden"
            >
              <ui-info
                v-if="isLiveVisits"
                :close="true"
                name="liveVisitClicksRestrictions"
                class="mr-4 ml-4 mt-6"
                width="w-auto"
              >
                <div>
                  {{
                    t(
                      'Only 500 records for the last 24 hours are available in this report. Export CSV to see 1000 records.',
                    )
                  }}
                </div>
                <div
                  v-html="
                    t(
                      'If you need more details on live visits/ live clicks data contact our support team through live chat.',
                    )
                  "
                ></div>
              </ui-info>

              <div class="main-menu__period-picker-row">
                <period-picker
                  ref="periodPicker"
                  v-if="isPeriodPickerVisible"
                  planLimits="compareReport"
                  class="main-menu__period-picker menu-layout__filter mr-4 ml-4 mt-6"
                />

                <ui-button
                  v-if="
                    isBasicReport ||
                    computedType === 'conversions' ||
                    computedType === 'postbacks'
                  "
                  class="hidden-sm-and-up mr-4 ml-4 mt-6"
                  icon="fas fa-search"
                  :button-style="store.report.showSearch ? 'accent' : 'default'"
                  @click="toggleSearch"
                ></ui-button>

                <report-settings
                  class="mr-4 ml-4 mt-6"
                  v-if="!display.smAndUp"
                  :is-custom="!isBasicReport"
                />

                <ui-button
                  class="hidden-sm-and-up mr-4 ml-4 mt-6"
                  :icon="isParamsChanged ? 'fas fa-check' : 'fas fa-sync-alt'"
                  :button-style="isParamsChanged ? 'accent' : 'outline-accent'"
                  @click="handleApply"
                ></ui-button>
              </div>

              <tag-search
                v-show="
                  isBasicReport ||
                  ['conversions', 'postbacks', 'errors'].includes(computedType)
                "
                class="mr-4 ml-4 mt-6"
                :class="{
                  'main-menu__tag-search': true,
                  'menu-layout__filter': true,
                  'menu-layout__filter--hide': !store.report.showSearch,
                }"
              ></tag-search>
              <menu-report class="hidden-sm-and-down" />
            </div>

            <div
              class="pickers-container"
              style="flex-grow: 0; display: flex; flex-wrap: wrap; align-items: center"
            >
              <ui-button
                class="hidden-sm-and-up mr-4 ml-4 mt-6"
                :text="t('More')"
                icon="fas fa-ellipsis-h"
                :button-style="store.report.showFilters ? 'accent' : 'default'"
                @click="toggleFilters"
              ></ui-button>

              <menu-report class="hidden-md-and-up mt-6" />

              <add-marks
                v-show="isAddMarksVissible"
                :key="route.path"
                class="tag-add-marks menu-layout__filter filter-picker--fix mr-4 ml-4 mt-6"
                :class="{
                  'menu-layout__filter--hide': !store.report.showFilters,
                }"
              ></add-marks>

              <status-picker
                v-show="!isReport && isBasicReportPlusConversionsPostbacks"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{
                  'menu-layout__filter--hide': !store.report.showFilters,
                }"
              ></status-picker>

              <view-picker
                v-if="showViewPicker"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{
                  'menu-layout__filter--hide': !store.report.showFilters,
                }"
              ></view-picker>

              <ui-button
                v-if="presetsList.length === 1 || tableQueryApi.tableActiveTab.value"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{ 'menu-layout__filter--hide': !store.report.showFilters }"
                icon="fas fa-eye"
                @click="handleMetricsPickerOpen"
              ></ui-button>

              <ui-button-multi
                v-if="presetsList.length > 1 && !tableQueryApi.tableActiveTab.value"
                :displayText="false"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{ 'menu-layout__filter--hide': !store.report.showFilters }"
                icon="fas fa-eye"
                :mainButtonClick="handleMetricsPickerOpen"
                :menuKeyOfSelectedItem="reportParamsApi.activePreset.value"
                :menu-list="presetsList"
              ></ui-button-multi>

              <ui-button
                planLimits="sharedReportsAmount"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{ 'menu-layout__filter--hide': !store.report.showFilters }"
                icon="fas fa-share-square"
                @click="handleShareReportOpen"
                :disabled="!isBasicReport"
                :helpTooltip="
                  !isBasicReport
                    ? t('Shared report can\'t be created for this type of report.')
                    : undefined
                "
              ></ui-button>
              <ui-button
                v-if="isBasicReport"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{ 'menu-layout__filter--hide': !store.report.showFilters }"
                icon="fas fa-chart-line"
                :button-style="tableQueryApi.tableChartOpen.value ? 'accent' : 'default'"
                @click="toggleChartPanel"
              ></ui-button>

              <ui-button
                v-if="isNotesVisible && isBasicReport"
                class="menu-layout__filter mr-4 ml-4 mt-6"
                :class="{ 'menu-layout__filter--hide': !store.report.showFilters }"
                icon="fas fa-comment-dots"
                :button-style="notesPanelVisible ? 'accent' : 'default'"
                :disabled="tableQueryApi.tableSelectedItems.value.length !== 1"
                @click="notesPanelVisible = !notesPanelVisible"
              ></ui-button>

              <report-settings
                class="mr-4 ml-4 mt-6"
                v-if="display.smAndUp"
                :is-custom="!isBasicReport"
              />

              <page-picker
                v-if="isPagePickerVisible"
                class="mr-4 ml-4 mt-6"
              ></page-picker>

              <ui-button
                class="mr-4 ml-4 hidden-xs mt-6"
                :text="isParamsChanged ? t('Apply') : t('Refresh')"
                :icon="isParamsChanged ? 'fas fa-check' : 'fas fa-sync-alt'"
                :button-style="isParamsChanged ? 'accent' : 'outline-accent'"
                @click="handleApply"
              ></ui-button>
            </div>
          </div>
          <ui-info
            v-if="isClientHintsNoticeVisible"
            :close="true"
            name="clientHintsNotice"
            class="mt-6"
            width="w-auto"
          >
            <div>
              <a href="/app/profile">
                {{
                  t(
                    'Activate Client Hints to get more details on OS, device, browser reports.',
                  )
                }}
              </a>
            </div>
          </ui-info>
        </div>
      </div>
    </template>
    <div
      v-if="isBasicReport"
      class="report-highcharts"
      style="display: flex; flex-direction: column"
    >
      <div class="w100" v-if="showChart">
        <div v-if="showChartEmptyText" class="chart-empty-text">
          {{ t('Select columns in settings to display data on the chart.') }}
        </div>
        <div v-else>
          <loading-circle v-if="isChartLoading" class="main-menu__loading-circle" />
          <div class="chart-wrp" v-else>
            <template v-if="!isDataRetentionTooOldDataRetrieved && chartOptions">
              <highcharts-wrapper ref="highcharts" :options="chartOptions" />
              <ui-button
                class="chart-series-toggle"
                @click="toggleCharts"
                size="mini"
                :text="isAllChartHidden ? t('Show all') : t('Hide all')"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useDisplay } from 'vuetify';
import { omit } from 'lodash';
import md5 from 'md5';

import { useI18n, useMenuBase, useReportParams, useTutorialApi, useUrlTableQuerySync } from '@/composables';
import { useReportChart } from '@/composables/useReportChart';
import { useReportFilters } from '@/composables/useReportFilters';
import { useTableQuery } from '@/composables/useTableQuery';
import { useUrl } from '@/composables/useUrl';
import { useStore } from '@/store';
import { $emitter } from '@/services/emitter';
import { forceCleanCache } from '@/services/utils/websocket';
import { GENERAL_PRESET } from '@/services/constants/report';
import { buildChartHashVarsForRoute } from '@/views/reports/report-route-behavior';
import { AppErrorEnum } from '@/services/models/Enums';
import { getAggregatedReportApiRequest } from '@/services/api/report-api';

import MenuReport from './navigation/menu-report.vue';
import MenuReportContextMenu from '@/views/layout/navigation/menu-report-context-menu.vue';
import MenuDrilldown from '@/views/reports/views/menu-drilldown/menu-drilldown.vue';
import StatusPicker from '@/views/reports/pickers/status-picker.vue';
import PeriodPicker from '@/views/reports/pickers/period-picker.vue';
import TagSearch from '@/views/reports/pickers/tag-search.vue';
import AddMarks from '@/views/reports/pickers/add-marks/add-marks.vue';
import PagePicker from '@/views/reports/pickers/page-picker.vue';
import ViewPicker from '@/views/reports/pickers/view-picker.vue';
import MainMenuGrouping from '@/views/layout/navigation/grouping/main-menu-grouping.vue';
import ReportSettings from '@/views/reports/pickers/report-settings.vue';
import LoadingCircle from '@/components/loading-circle.vue';
import MenuTreeLevels from '@/views/reports/views/tree-levels.vue';
import HighchartsWrapper from './highcharts-wrapper.vue';

const emit = defineEmits(['showCharts']);

const store = useStore();
const reportParamsApi = useReportParams();
const route = useRoute();
const display = useDisplay();
const { t } = useI18n();
const tableQueryApi = useTableQuery();
useUrlTableQuerySync();
const {
  computedType,
  currentReportType,
  drilldown,
  getLink,
  isBasicReport,
  isClientHintsNoticeVisible,
  isDashboard,
  isLiveVisits,
  isMainTab,
  isCustomTab,
  isReport,
  mainTabs,
  reportDrillCampaign,
} = useUrl();
const { report } = useMenuBase();
const { getReportFilters } = useReportFilters();
const {
  aggregatedValue,
  chartOptions,
  getInitialChartOptions,
  handleChartResponse,
  isAllChartHidden,
} = useReportChart();

const supportedMetricsAsObject = computed(() => store.getSupportedMetricsAsObject());

const tutorialApi = useTutorialApi(getLink);

const highcharts = ref<{
  chart?: {
    series: { setVisible: (visible: boolean, redraw: boolean) => void }[];
    redraw: () => void;
  };
}>();
const isChartLoading = ref(false);
const showChartEmptyText = ref(false);
const error = ref<any>(null);

const disableTreeViewList = ['ips', 'useragents', 'referrers'];
const isTreeLevelsAllowed = computed(
  () => !disableTreeViewList.includes(computedType.value),
);

const isBasicReportPlusConversionsPostbacks = computed(
  () => !['errors', 'live-visits', 'live-clicks'].includes(computedType.value),
);

const isPeriodPickerVisible = computed(() => !isLiveVisits.value);
const isPagePickerVisible = computed(() => !isLiveVisits.value);

const showViewPicker = computed(
  () =>
    isReport.value &&
    tableQueryApi.tableQueryForCurrentTab.value.treeLevels?.filter((item: unknown) => !!item)
      .length,
);

const filteredSelectedItems = computed(() =>
  tableQueryApi.tableSelectedItems.value
    ? (tableQueryApi.tableSelectedItems.value as Array<{ DT_RowId: string; grouping?: string }>).filter(
        ({ DT_RowId }) => DT_RowId !== 'Unknown',
      )
    : [],
);

const isAddMarksVissible = computed(() => {
  const { grouping } = filteredSelectedItems.value[0] || {};
  return (
    isMainTab.value ||
    isCustomTab.value ||
    grouping?.startsWith('reports-custom') ||
    mainTabs.value.includes(grouping?.replace('-name', '').replace('_', '-'))
  );
});

const presetsList = computed(() => {
  return reportParamsApi.presetsInfo.value.map(item => ({
    key: item.presetId,
    title: item.presetId === GENERAL_PRESET ? t('____x.generalPreset') : item.presetName,
    click: () => {
      store.setActivePreset(item.presetId);
      store.replaceTableColumnsFiltersForCurrentTab({});
      $emitter.emit('update-table-filters');
      handleApply({ resetPagination: true });
    },
  }));
});

const notesPanelVisible = computed({
  get: () => tableQueryApi.tableNotesOpened.value,
  set: (value: boolean) => store.setTableNotesOpened(value),
});

const isNotesVisible = computed(
  () => computedType.value === 'campaigns' || !!reportDrillCampaign.value,
);

const buildHashVars = (temporary: boolean) => {
  const searchSource = temporary
    ? tableQueryApi.tableQueryTemporarySearch.value
    : tableQueryApi.tableQuerySearch.value;
  const querySource = temporary
    ? tableQueryApi.tableQueryTemporaryForCurrentTab.value
    : tableQueryApi.tableQueryForCurrentTab.value;
  const {
    searchBy,
    textValue,
    tagsValue,
    marksValue,
    tagsLogicalRelation,
    textLogicalRelation,
    marksFilterMode,
  } = searchSource as {
    searchBy?: string;
    textValue?: unknown;
    tagsValue?: unknown;
    marksValue?: unknown;
    tagsLogicalRelation?: unknown;
    textLogicalRelation?: unknown;
    marksFilterMode?: string;
  };
  const {
    treeLevels,
    view,
    from,
    to,
    timezone,
    compareEnabled,
    compareFrom,
    compareTo,
    compareDate,
  } = querySource;
  const searchParams = {
    ...(searchBy?.startsWith('text')
      ? { searchBy: 'text', textValue, textLogicalRelation }
      : {}),
    ...(searchBy === 'marks' || searchBy?.startsWith('marks-')
      ? {
          searchBy: 'marks',
          marksValue,
          marksFilterMode:
            marksFilterMode || (searchBy?.includes('exclude') ? 'exclude' : 'include'),
        }
      : {}),
    ...(searchBy?.startsWith('tags')
      ? { searchBy: 'tags', tagsValue, tagsLogicalRelation }
      : {}),
  };

  return buildChartHashVarsForRoute({
    routeName: route.name,
    from,
    to,
    timezone,
    compareEnabled: !!reportParamsApi.reportParams.value.compareEnabled,
    compareFrom,
    compareTo,
    compareDate,
    searchParams,
    treeLevels,
    view,
  });
};

const currentHash = computed(() => md5(JSON.stringify(buildHashVars(true))));
const oldHash = computed(() => md5(JSON.stringify(buildHashVars(false))));
const isParamsChanged = computed(() => currentHash.value !== oldHash.value);

const showChart = computed(
  () => tableQueryApi.tableChartOpen.value && (route.path || '').includes('/report'),
);

const isDataRetentionTooOldDataRetrieved = computed(
  () =>
    error.value?.response?.status === 402 &&
    error.value?.response?.data?.message ===
      AppErrorEnum.dataRetentionTooOldDataRetrieved,
);

const handleShareReportOpen = () => {
  $emitter.emit('open-dialog', { name: 'ShareReportDialog' });
};

const handleMetricsPickerOpen = () => {
  $emitter.emit('open-dialog', { name: 'ColumnsSettingsDialog' });
};

const toggleFilters = () => {
  store.setShowFilters(!store.report.showFilters);
};

const toggleSearch = () => {
  store.setShowSearch(!store.report.showSearch);
};

const toggleChartPanel = () => {
  emit('showCharts');
  store.setTableChartOpen(!tableQueryApi.tableChartOpen.value);
};

const handleApply = (_params?: { resetPagination?: boolean }) => {
  if (!isParamsChanged.value) forceCleanCache();
  $emitter.emit('apply-filters');
  $emitter.emit('reload-report');
};

const getChartData = async () => {
  showChartEmptyText.value = false;
  let params = omit(reportParamsApi.reportParams.value, [
    'limit',
    'offset',
    'formatResponse',
    'orderBy',
    'orderDir',
    'tree',
    'view',
    'compareEnabled',
    'compareDate',
    'compareTo',
    'compareFrom',
  ]);

  params = {
    ...params,
    ...getReportFilters(),
    columns: params.columns?.filter(
      (column: string) => supportedMetricsAsObject.value[column],
    ),
  };

  const { selectedWorkspaces, workspaces } = store.user;
  if (selectedWorkspaces?.length === workspaces?.length) {
    delete params.workspaceIds;
  } else {
    params.workspaceIds = selectedWorkspaces;
  }

  if (tableQueryApi.tableQueryForCurrentTab.value.compareEnabled) {
    const { compareFrom, compareTo, compareDate } = tableQueryApi.tableQueryForCurrentTab.value;
    params.compareFrom = compareFrom;
    params.compareTo = compareTo;
    params.compareDate = compareDate;
  }

  if (params.columns.length === 0) {
    showChartEmptyText.value = true;
    return;
  }

  isChartLoading.value = true;
  error.value = null;
  chartOptions.value = JSON.parse(JSON.stringify(getInitialChartOptions()));
  chartOptions.value.compareEnabled =
    tableQueryApi.tableQueryForCurrentTab.value.compareEnabled;

  try {
    const payload = await getAggregatedReportApiRequest(aggregatedValue.value, params);
    handleChartResponse({
      data: payload.data,
      isCompare: false,
    });
    if (payload.compareData) {
      handleChartResponse({
        data: payload.compareData,
        isCompare: true,
      });
    }
  } catch (chartError) {
    error.value = chartError;
  } finally {
    isChartLoading.value = false;
  }
};

const chartReload = () => {
  if (showChart.value) {
    getChartData();
  }
};

const toggleCharts = () => {
  const chart = highcharts.value?.chart;
  if (!chart?.series) return;
  const allHidden = isAllChartHidden.value;
  chart.series.forEach(item => {
    item.setVisible(allHidden, false);
  });
  chart.redraw();
};

const onBusRefreshChart = () => {
  chartReload();
};

watch(
  () => store.tutorial.quickStartStep,
  value => {
    tutorialApi.firstStep(value);
  },
);

watch(
  () => tableQueryApi.tableChartOpen.value,
  value => {
    if (value) {
      getChartData();
    }
  },
);

watch(
  () => tableQueryApi.tableSelectedItems.value,
  items => {
    if (notesPanelVisible.value && items.length !== 1) {
      notesPanelVisible.value = false;
    }
  },
);

onMounted(() => {
  $emitter.on('refresh-chart', onBusRefreshChart);
  $emitter.on('row-report', report);
  $emitter.on('click-apply-filters', handleApply);
});

onBeforeUnmount(() => {
  $emitter.off('row-report', report);
  $emitter.off('refresh-chart', onBusRefreshChart);
  $emitter.off('click-apply-filters', handleApply);
});
</script>

<style lang="scss">
@import '@/styles/components/main-menu';

.main-menu__title {
  //height: 100%;
  font-family: Lato;
  font-size: 30px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--color-black);
  // padding-top: 15px;
  align-self: flex-start;
  padding-top: 0 !important;
}

.main-menu__period-picker {
  @media (max-width: 600px) {
    flex-grow: 1;
  }
}

.main-menu__tag-search {
  width: 216px;
  overflow: hidden;

  @media (max-width: 600px) {
    width: 100%;
    flex-grow: 1;
  }
}

.main-menu__period-picker-row {
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-grow: 1;
  }
}

.main-menu__drilldown-row {
  display: flex;
  flex-grow: 1;
  max-width: unset;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  margin: 0 -4px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
}

.main-menu__loading-circle {
  width: 100%;
  height: 400px;
  background-color: var(--color-gray5);
}
</style>

<style scoped lang="scss">
.report-highcharts {
  background: var(--color-gray5);
}

.pickers-container {
  margin-right: -4px;
  margin-left: -4px;
}

.chart-wrp {
  position: relative;
}

.chart-series-toggle {
  display: flex;
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.chart-empty-text {
  padding: 40px 0;
  text-align: center;
}
</style>
